import React from 'react';
import propTypes from 'prop-types';
import BaseLoginRedirectPage from './BaseLoginRedirectPage';
import LoginInterstitial from './LoginInterstitial';
import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

export default function LoginRedirectPage(props) {
  const { orgSwitcherInterstitialMvpEnabled } = useFeatureEnabled(FEATURE_FLAGS.orgSwitcherInterstitialMvp);

  if (orgSwitcherInterstitialMvpEnabled) {
    return <LoginInterstitial {...props} />;
  }

  return <BaseLoginRedirectPage {...props} />;
}

LoginRedirectPage.propTypes = {
  location: propTypes.shape({
    search: propTypes.string.isRequired,
  }).isRequired,
};
